// /components/NavBar.jsx

"use client";

import React, { useState, useEffect, useContext } from "react";
import "./NavBar.scss";
import { MenuToggle } from "./MenuToggle";
import { motion, useCycle } from "framer-motion";
import Navigation from "./Navigation";
import ScreenContext from "../../context/ScreenContext";

export default function NavBar({ links, setIsOpen }) {
  const [isOpen, toggleOpen] = useCycle(false, true);
  const s = useContext(ScreenContext);
  const scroll = s.scroll;

  const handleScroll = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  return (
    <>
      <div
        className={`hamburger-nav-bar ${scroll > 100 || s?.desktop === false ? "show" : ""
          }`}
      >
        <motion.div
          className={`nav-bar-dialog ${isOpen && !s.mobile ? "show" : ""}`}
          onClick={() => {
            toggleOpen();
            setIsOpen(!isOpen);
          }}
        />
        <Navigation
          isOpen={isOpen}
          toggle={() => {
            toggleOpen();
            setIsOpen(!isOpen);
          }}
          items={links}
        />
        <MenuToggle
          toggle={() => {
            toggleOpen();
            setIsOpen(!isOpen);
          }}
          open={isOpen}
          mobile={s.mobile}
        />
      </div>
      <div className={`top-nav-bar ${scroll < 100 && s.desktop ? "show" : ""}`}>
        <ul
          className="top-nav-bar-list"
        >
          {links.map((link, index) => (
            <li
              className={`top-nav-bar-list-item ${scroll < 100 && s.mobile === false ? "show" : ""
                }`}
              key={index}
              onClick={() => handleScroll(link.targetId)}
            >
              {link.name}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
